import React__default from 'react';
import { makeStyles, useTheme, Box, Typography } from '@material-ui/core';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';
import PropTypes__default from 'prop-types';
import { BUTTON_TYPES } from '../../common/constant.js';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: theme.spacing(83.75)
    },
    image: {
      zIndex: "-1",
      position: "absolute",
      height: "100% !important",
      width: "100% !important",
      objectFit: "cover"
    },
    text: {
      color: theme.palette.grey[0]
    },
    textContained: {
      color: theme.palette.text.black
    },
    cta: {
      marginTop: theme.spacing(7)
    }
  };
});
var BackgroundImageTextCta = function BackgroundImageTextCta(_ref) {
  var imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    buttons = _ref.buttons,
    onButtonClick = _ref.onButtonClick;
  var classes = useStyles();
  var theme = useTheme();
  var _window = window,
    width = _window.innerWidth,
    height = _window.innerHeight;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.wrapper
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: classes.image,
    src: retrieveContentfulImage(imageUrl, {
      width: width,
      height: height,
      fit: "fill"
    }),
    alt: imageTitle || ""
  }), /*#__PURE__*/React__default.createElement(Box, {
    maxWidth: theme.spacing(75),
    textAlign: "center"
  }, title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    component: "h2",
    className: classes.text
  }, title), /*#__PURE__*/React__default.createElement(Box, {
    className: classes.cta
  }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (i) {
    var _i$button, _BUTTON_TYPES$i$butto, _i$button2, _BUTTON_TYPES$i$butto2, _i$button3, _i$button4, _BUTTON_TYPES$i$butto3, _i$button6, _BUTTON_TYPES$i$butto4, _i$button7, _i$button8;
    return /*#__PURE__*/React__default.createElement(Box, {
      mb: 4,
      key: i === null || i === void 0 || (_i$button = i.button) === null || _i$button === void 0 ? void 0 : _i$button.id
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      variant: ((_BUTTON_TYPES$i$butto = BUTTON_TYPES[i === null || i === void 0 || (_i$button2 = i.button) === null || _i$button2 === void 0 ? void 0 : _i$button2.type]) === null || _BUTTON_TYPES$i$butto === void 0 ? void 0 : _BUTTON_TYPES$i$butto.variant) || "contained",
      color: (_BUTTON_TYPES$i$butto2 = BUTTON_TYPES[i === null || i === void 0 || (_i$button3 = i.button) === null || _i$button3 === void 0 ? void 0 : _i$button3.type]) === null || _BUTTON_TYPES$i$butto2 === void 0 ? void 0 : _BUTTON_TYPES$i$butto2.color,
      href: i === null || i === void 0 || (_i$button4 = i.button) === null || _i$button4 === void 0 ? void 0 : _i$button4.url,
      onClick: function onClick() {
        var _i$button5;
        return onButtonClick(i === null || i === void 0 || (_i$button5 = i.button) === null || _i$button5 === void 0 ? void 0 : _i$button5.id);
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle1",
      component: "span",
      className: (((_BUTTON_TYPES$i$butto3 = BUTTON_TYPES[i === null || i === void 0 || (_i$button6 = i.button) === null || _i$button6 === void 0 ? void 0 : _i$button6.type]) === null || _BUTTON_TYPES$i$butto3 === void 0 ? void 0 : _BUTTON_TYPES$i$butto3.color) || "primary") === "primary" && (((_BUTTON_TYPES$i$butto4 = BUTTON_TYPES[i === null || i === void 0 || (_i$button7 = i.button) === null || _i$button7 === void 0 ? void 0 : _i$button7.type]) === null || _BUTTON_TYPES$i$butto4 === void 0 ? void 0 : _BUTTON_TYPES$i$butto4.variant) || "contained") !== "outlined" ? classes.textContained : classes.text
    }, i === null || i === void 0 || (_i$button8 = i.button) === null || _i$button8 === void 0 ? void 0 : _i$button8.label)));
  }))));
};
BackgroundImageTextCta.propTypes = {
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  title: PropTypes__default.string,
  buttons: PropTypes__default.array,
  onButtonClick: PropTypes__default.func
};

export { BackgroundImageTextCta as default };
//# sourceMappingURL=BackgroundImageTextCta.js.map
